/**
 * Information functions of the Core_Formula_Set (Requirement 4.1).
 *
 * These are the functions that must see an argument *before* coercion, so they
 * are all `errorTolerant` and they inspect the raw value. `ISBLANK` in
 * particular has to distinguish a blank cell from an empty string, which is why
 * the evaluator passes references through unresolved.
 */

import { isError, bool, toScalar, type FnSpec, type Value } from '../values.js';

/** One-argument predicate over the raw first argument. */
function predicate(name: string, test: (v: Value, resolved: ReturnType<typeof toScalar>) => boolean): FnSpec {
  return {
    name,
    min: 1,
    max: 1,
    errorTolerant: true,
    fn: (args, ctx) => {
      const raw = args[0] as Value;
      return bool(test(raw, toScalar(raw, ctx)));
    },
  };
}

export const INFO_FUNCTIONS: readonly FnSpec[] = [
  predicate('ISBLANK', (_raw, resolved) => resolved.k === 'empty'),
  predicate('ISNUMBER', (_raw, resolved) => resolved.k === 'number'),
  predicate('ISTEXT', (_raw, resolved) => resolved.k === 'text'),
  predicate('ISERROR', (_raw, resolved) => isError(resolved)),
];
